module.exports = __webpack_public_path__ + "img/uizalabs.1c1b5c85.webp";